import { call, put, takeLatest } from "redux-saga/effects";
import {
  RequestDistinctHosts,
  SuccessDistinctHosts,
  FailureDistinctHosts,
  RequestDistinctLiveHosts,
  SuccessDistinctLiveHosts,
  FailureDistinctLiveHosts,
  RequestAnalyzedEmails,
  SuccessAnalyzedEmails,
  FailureAnalyzedEmails,
  RequestBlockedEmails,
  SuccessBlockedEmails,
  FailureBlockedEmails,
  RequestUnblockedEmails,
  SuccessUnblockedEmails,
  FailureUnblockedEmails,
  RequestReleaseEmail,
  SuccessReleaseEmail,
  FailureReleaseEmail,
  RequestSetMailTransferSettings,
  SuccessSetMailTransferSettings,
  FailureSetMailTransferSettings,
  RequestGetMailTransferSettings,
  SuccessGetMailTransferSettings,
  FailureGetMailTransferSettings,
  RequestGetWhitelistSettings,
  SuccessGetWhitelistSettings,
  FailureGetWhitelistSettings,
  RequestSetWhitelistSettings,
  SuccessSetWhitelistSettings,
  FailureSetWhitelistSettings,
  RequestGetBlacklistSettings,
  SuccessGetBlacklistSettings,
  FailureGetBlacklistSettings,
  RequestSetBlacklistSettings,
  SuccessSetBlacklistSettings,
  FailureSetBlacklistSettings,
  RequestAptAnalysisStatus,
  SuccessAptAnalysisStatus,
  FailureAptAnalysisStatus,
  RequestDashboardInsights,
  SuccessDashboardInsights,
  FailureDashboardInsights,
  RequestTransferLogs,
  SuccessTransferLogs,
  FailureTransferLogs,
  RequestGetUrlSettings,
  SuccessGetUrlSettings,
  FailureGetUrlSettings,
  RequestSetUrlSettings,
  SuccessSetUrlSettings,
  FailureSetUrlSettings,
  RequestGetUrl2Settings,
  SuccessGetUrl2Settings,
  FailureGetUrl2Settings,
  RequestSetUrl2Settings,
  SuccessSetUrl2Settings,
  FailureSetUrl2Settings,
  RequestGetSandboxSettings,
  SuccessGetSandboxSettings,
  FailureGetSandboxSettings,
  RequestSetSandboxSettings,
  SuccessSetSandboxSettings,
  FailureSetSandboxSettings,
  RequestToggleUrlSettings,
  RequestToggleUrl2Settings,
  RequestGetSpamSettings,
  SuccessGetSpamSettings,
  FailureGetSpamSettings,
  RequestSetSpamSettings,
  SuccessSetSpamSettings,
  FailureSetSpamSettings,
  RequestToggleSpamSettings,
  RequestGetEmailNotificationSettings,
  SuccessGetEmailNotificationSettings,
  FailureGetEmailNotificationSettings,
  RequestSetEmailNotificationSettings,
  SuccessSetEmailNotificationSettings,
  FailureSetEmailNotificationSettings,
  RequestResetSettings,
  SuccessResetSettings,
  FailureResetSettings,
  RequestRepairSettings,
  SuccessRepairSettings,
  FailureRepairSettings,
  RequestGetFileTypeSettings,
  SuccessGetFileTypeSettings,
  FailureGetFileTypeSettings,
  RequestSetFileTypeSettings,
  SuccessSetFileTypeSettings,
  FailureSetFileTypeSettings,
  RequestGetGeneralSettings,
  SuccessGetGeneralSettings,
  FailureGetGeneralSettings,
  RequestSetGeneralSettings,
  SuccessSetGeneralSettings,
  FailureSetGeneralSettings,
  RequestGetCertificateFile,
  SuccessGetCertificateFile,
  FailureGetCertificateFile,
  RequestSetCertificateFile,
  SuccessSetCertificateFile,
  FailureSetCertificateFile,
  RequestGetKeyFile,
  SuccessGetKeyFile,
  FailureGetKeyFile,
  RequestSetKeyFile,
  SuccessSetKeyFile,
  FailureSetKeyFile,
  RequestSendTestEmail,
  SuccessSendTestEmail,
  FailureSendTestEmail,
  RequestGetAlertSettings,
  SuccessGetAlertSettings,
  FailureGetAlertSettings,
  RequestSetAlertSettings,
  SuccessSetAlertSettings,
  FailureSetAlertSettings,
  RequestNextHops,
  SuccessNextHops,
  FailureNextHops,
} from "../actions/mailGatewayActions";
import { addNotification } from "../actions/notifierActions";

import axiosApi from "../../utils/axios";
import { customFormData } from "../../utils/customFormData";
import { viewerTimeZone } from "../../Pages/MailGateway/util";

export function* distinctHosts() {
  try {
    const response = yield call(axiosApi.get, "/api/mail-gateway/hosts");
    const mappedData = response?.data?.map((item) => ({ id: item, value: item }));
    yield put(SuccessDistinctHosts(mappedData));
  } catch (e) {
    yield put(FailureDistinctHosts());
  }
}

export function* distinctLiveHosts() {
  try {
    const response = yield call(axiosApi.get, "/api/mail-gateway/live-hosts");
    const mappedData = response?.data ? response.data : [];

    yield put(SuccessDistinctLiveHosts(mappedData));
  } catch (e) {
    yield put(FailureDistinctLiveHosts());
  }
}

export function* analyzedEmails({ payload }) {
  const { host, timeFilter } = payload;
  try {
    const response = yield call(
      axiosApi.get,
      `/api/mail-gateway/analyzed-emails/${host}?filterByLast=${timeFilter.id}`,
    );
    yield put(SuccessAnalyzedEmails(response.data));
  } catch (e) {
    yield put(FailureAnalyzedEmails());
  }
}

export function* blockedEmails({ payload }) {
  const { host, timeFilter } = payload;
  try {
    const response = yield call(
      axiosApi.get,
      `/api/mail-gateway/blocked-emails/${host}?filterByLast=${timeFilter.id}`,
    );
    yield put(SuccessBlockedEmails(response.data));
  } catch (e) {
    yield put(FailureBlockedEmails());
  }
}

export function* unblockedEmails({ payload }) {
  const { host, timeFilter } = payload;
  try {
    const response = yield call(
      axiosApi.get,
      `/api/mail-gateway/unblocked-emails/${host}?filterByLast=${timeFilter.id}`,
    );
    yield put(SuccessUnblockedEmails(response.data));
  } catch (e) {
    yield put(FailureUnblockedEmails());
  }
}

export function* releaseEmail({ payload }) {
  const { emailId, host } = payload;

  let parsedData = {};
  const storedData = localStorage.getItem("blockedEmails");
  if (storedData) {
    parsedData = JSON.parse(storedData);
  }

  try {
    yield call(axiosApi.post, `/api/mail-gateway/release-email/${emailId}/${host}`);
    yield put(SuccessReleaseEmail());
    yield call(blockedEmails, { payload: { host, timeFilter: parsedData } });
    yield put(
      addNotification({ message: "Release email successful", options: { variant: "success" } }),
    );
  } catch (e) {
    yield put(FailureReleaseEmail());
    yield put(
      addNotification({
        message: e?.response?.data?.message,
        options: { variant: "error" },
        time: 4000,
      }),
    );
  }
}

export function* setMailTransferSettings({ payload }) {
  const { hostname, settings } = payload;
  try {
    const response = yield call(
      axiosApi.post,
      `/api/mail-gateway/settings/mail-transfer/${hostname}`,
      settings,
    );
    yield put(SuccessSetMailTransferSettings(response.data));
    yield put(
      addNotification({
        message: "Settings updated successfully",
        options: { variant: "success" },
      }),
    );
    yield call(getMailTransferSettings, { payload: { hostname } });
  } catch (e) {
    yield put(FailureSetMailTransferSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to update settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getMailTransferSettings({ payload }) {
  const { hostname } = payload;
  try {
    const response = yield call(
      axiosApi.get,
      `/api/mail-gateway/settings/mail-transfer/${hostname}`,
    );
    yield put(SuccessGetMailTransferSettings(response.data));
  } catch (e) {
    yield put(FailureGetMailTransferSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to fetch settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getWhitelistSettings({ payload }) {
  const { hostname } = payload;
  try {
    const response = yield call(axiosApi.get, `/api/mail-gateway/settings/whitelist/${hostname}`);
    yield put(SuccessGetWhitelistSettings(response.data["whitelist"]));
  } catch (e) {
    yield put(FailureGetWhitelistSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to fetch settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setWhitelistSettings({ payload }) {
  const { hostname, settings } = payload;
  try {
    const response = yield call(axiosApi.post, `/api/mail-gateway/settings/whitelist/${hostname}`, {
      whitelist: settings,
    });
    yield put(SuccessSetWhitelistSettings());
    yield call(getWhitelistSettings, { payload: { hostname } });
    yield put(
      addNotification({
        message: "Whitelist settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetWhitelistSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to update settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getBlacklistSettings({ payload }) {
  const { hostname } = payload;
  try {
    const response = yield call(axiosApi.get, `/api/mail-gateway/settings/blacklist/${hostname}`);
    yield put(SuccessGetBlacklistSettings(response.data["blacklist"]));
  } catch (e) {
    yield put(FailureGetBlacklistSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to fetch settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setBlacklistSettings({ payload }) {
  const { hostname, settings } = payload;
  try {
    const response = yield call(axiosApi.post, `/api/mail-gateway/settings/blacklist/${hostname}`, {
      blacklist: settings,
    });
    yield put(SuccessSetBlacklistSettings());
    yield call(getBlacklistSettings, { payload: { hostname } });
    yield put(
      addNotification({
        message: "Blacklist settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetBlacklistSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to update settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* aptAnalysisStatus({ payload: host }) {
  const replacedHost = host.replace("postfix.", "");
  try {
    const response = yield call(
      axiosApi.get,
      `/api/mail-gateway/apt-analysis-status/${replacedHost}`,
    );
    yield put(SuccessAptAnalysisStatus(response.data));
  } catch (e) {
    yield put(FailureAptAnalysisStatus());
  }
}

// Column searches arrive as react-table filters ({ id: accessor, value })
export function* transferLogs({ payload }) {
  const { host, selectedTimeFilter, pageNumber, pageSize, search, statusTab, filters = [] } =
    payload;
  try {
    const params = {
      filterByLast: selectedTimeFilter?.id,
      pageNumber,
      pageSize,
      search: search || undefined,
      statusTab: statusTab || undefined,
      ...Object.fromEntries(filters.map((filter) => [filter.id, filter.value])),
    };
    const response = yield call(
      axiosApi.get,
      `/api/mail-gateway/transfer-logs/${host.replace("postfix.", "")}`,
      { params, timeout: 30000 },
    );
    yield put(SuccessTransferLogs(response.data));
  } catch (e) {
    yield put(FailureTransferLogs());
  }
}

export function* dashboardInsights({ payload: host }) {
  const replacedHost = host.replace("postfix.", "");
  try {
    const response = yield call(
      axiosApi.get,
      `/api/mail-gateway/dashboard-insights/${replacedHost}`,
      { params: { tz: viewerTimeZone() } },
    );
    yield put(SuccessDashboardInsights(response.data));
  } catch (e) {
    yield put(FailureDashboardInsights());
  }
}

export function* getUrlSettings({ payload: host }) {
  try {
    const response = yield call(axiosApi.get, `/api/mail-gateway/settings/url/${host}`);
    yield put(SuccessGetUrlSettings(response?.data?.url_settings));
  } catch (e) {
    yield put(FailureGetUrlSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to get url settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setUrlSettings({ payload }) {
  const { host, reqBody } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/url/${host}`, reqBody);
    yield put(SuccessSetUrlSettings());
    yield call(getUrlSettings, { payload: host });
    yield put(
      addNotification({
        message: "Defined settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetUrlSettings());
    yield put(
      addNotification({
        message: "Failed to set url settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getUrl2Settings({ payload: host }) {
  try {
    const response = yield call(axiosApi.get, `/api/mail-gateway/settings/url2/${host}`);
    yield put(SuccessGetUrl2Settings(response?.data?.url_settings));
  } catch (e) {
    yield put(FailureGetUrl2Settings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to get url rewrite settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setUrl2Settings({ payload }) {
  const { host, reqBody } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/url2/${host}`, reqBody);
    yield put(SuccessSetUrl2Settings());
    yield call(getUrl2Settings, { payload: host });
    yield put(
      addNotification({
        message: "Defined settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetUrl2Settings());
    yield put(
      addNotification({
        message: "Failed to set url rewrite settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getSandboxSettings({ payload: host }) {
  try {
    const response = yield call(axiosApi.get, `/api/mail-gateway/settings/sandbox/${host}`);
    yield put(SuccessGetSandboxSettings(response?.data?.sandbox_settings));
  } catch (e) {
    yield put(FailureGetSandboxSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to get sandbox settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setSandboxSettings({ payload }) {
  const { host, reqBody } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/sandbox/${host}`, reqBody);
    yield put(SuccessSetSandboxSettings());
    yield call(getSandboxSettings, { payload: host });
    yield put(
      addNotification({
        message: "Defined settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetSandboxSettings());
    yield put(
      addNotification({
        message: "Failed to set sandbox settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* toggleUrlSettings({ payload }) {
  const { host, url_settings_status } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/url/${host}`, {
      url_settings_status,
    });
    yield call(getUrlSettings, { payload: host });
  } catch (e) {
    yield put(
      addNotification({
        message: "Failed to toggle url settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* toggleUrl2Settings({ payload }) {
  const { host, url_rewrite } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/url2/${host}`, {
      url_rewrite,
    });
    yield call(getUrl2Settings, { payload: host });
  } catch (e) {
    yield put(
      addNotification({
        message: "Failed to toggle url rewrite settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getSpamSettings({ payload: host }) {
  try {
    const response = yield call(axiosApi.get, `/api/mail-gateway/settings/spam/${host}`);
    yield put(SuccessGetSpamSettings(response?.data?.spam_settings));
  } catch (e) {
    yield put(FailureGetSpamSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to get spam settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setSpamSettings({ payload }) {
  const { host, reqBody } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/spam/${host}`, reqBody);
    yield put(SuccessSetSpamSettings());
    yield call(getSpamSettings, { payload: host });
    yield put(
      addNotification({
        message: "Defined settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetSpamSettings());
    yield put(
      addNotification({
        message: "Failed to set spam settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* toggleSpamSettings({ payload }) {
  const { host, spam_settings_status } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/spam/${host}`, {
      spam_settings_status,
    });
    yield call(getSpamSettings, { payload: host });
  } catch (e) {
    yield put(
      addNotification({
        message: "Failed to toggle spam settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getEmailNotificationSettings({ payload: host }) {
  try {
    const response = yield call(
      axiosApi.get,
      `/api/mail-gateway/settings/email-notification/${host}`,
    );
    yield put(SuccessGetEmailNotificationSettings(response?.data?.email_notification_settings));
  } catch (e) {
    yield put(FailureGetEmailNotificationSettings());
    yield put(
      addNotification({
        message: "Failed to get email notification settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setEmailNotificationSettings({ payload }) {
  const { host, reqBody } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/email-notification/${host}`, reqBody);
    yield put(SuccessSetEmailNotificationSettings());
    yield call(getEmailNotificationSettings, { payload: host });
    yield put(
      addNotification({
        message: "Defined settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetEmailNotificationSettings());
    yield put(
      addNotification({
        message: "Failed to set email notification settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* resetSettings({ payload: host }) {
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/reset-settings/${host}`);
    yield put(SuccessResetSettings());
    yield call(getMailTransferSettings, { payload: { hostname: host } });
    yield put(
      addNotification({
        message: "Reset settings successfull",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureResetSettings());
    yield put(
      addNotification({
        message: "Failed to reset settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* repairSettings({ payload: host }) {
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/repair-settings/${host}`);
    yield put(SuccessRepairSettings());
    yield call(getMailTransferSettings, { payload: { hostname: host } });
    yield put(
      addNotification({
        message: "Repair settings successfull",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureRepairSettings());
    yield put(
      addNotification({
        message: "Failed to repair settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getFileTypeSettings({ payload: host }) {
  try {
    const response = yield call(axiosApi.get, `/api/mail-gateway/settings/file-types/${host}`);
    yield put(SuccessGetFileTypeSettings(response.data["file_types"]));
  } catch (e) {
    yield put(FailureGetFileTypeSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to fetch file type settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setFileTypeSettings({ payload }) {
  const { hostname, settings } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/file-types/${hostname}`, {
      file_types: settings,
    });
    yield put(SuccessSetFileTypeSettings());
    yield call(getFileTypeSettings, { payload: hostname });
    yield put(
      addNotification({
        message: "File type settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetFileTypeSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to update file type settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getGeneralSettings({ payload: host }) {
  try {
    const response = yield call(axiosApi.get, `/api/mail-gateway/settings/general/${host}`);
    yield put(SuccessGetGeneralSettings(response.data["general_settings"]));
  } catch (e) {
    yield put(FailureGetGeneralSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to fetch general settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setGeneralSettings({ payload }) {
  const { host, reqBody } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/general/${host}`, reqBody);
    yield put(SuccessSetGeneralSettings());
    yield call(getGeneralSettings, { payload: host });
    yield put(
      addNotification({
        message: "General settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetGeneralSettings());
    yield put(
      addNotification({
        message: "Failed to set general settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getCertificateFile({ payload: host }) {
  try {
    const response = yield call(
      axiosApi.get,
      `/api/mail-gateway/settings/certificate-file/${host}`,
    );
    yield put(SuccessGetCertificateFile(response?.data?.certificate_file));
  } catch (e) {
    yield put(FailureGetCertificateFile());
    yield put(
      addNotification({
        message: "Failed to get certificate",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setCertificateFile({ payload }) {
  const { host, file } = payload;
  try {
    const formData = customFormData({});
    formData.append("file", file);

    yield call(axiosApi.post, `/api/mail-gateway/settings/certificate-file/${host}`, formData);
    yield call(getCertificateFile, { payload: host });
    yield put(SuccessSetCertificateFile());
    yield put(
      addNotification({
        message: "Uploaded certificate file successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetCertificateFile());
    yield put(
      addNotification({
        message: "Failed to upload certificate file",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getKeyFile({ payload: host }) {
  try {
    const response = yield call(axiosApi.get, `/api/mail-gateway/settings/key-file/${host}`);
    yield put(SuccessGetKeyFile(response?.data?.key_file));
  } catch (e) {
    yield put(FailureGetKeyFile());
    yield put(
      addNotification({
        message: "Failed to get key",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setKeyFile({ payload }) {
  const { host, file } = payload;
  try {
    const formData = customFormData({});
    formData.append("file", file);

    yield call(axiosApi.post, `/api/mail-gateway/settings/key-file/${host}`, formData);
    yield call(getKeyFile, { payload: host });
    yield put(SuccessSetKeyFile());
    yield put(
      addNotification({
        message: "Uploaded key file successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetKeyFile());
    yield put(
      addNotification({
        message: "Failed to upload key file",
        options: { variant: "error" },
      }),
    );
  }
}

export function* sendTestEmail({ payload }) {
  const { host, reqBody, target } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/test-email/${host}`, reqBody);
    yield put(SuccessSendTestEmail());
    yield put(
      addNotification({
        message: "Send test email successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSendTestEmail());
    yield put(
      addNotification({
        message: "Failed to send test email",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getAlertSettings({ payload: host }) {
  try {
    const response = yield call(axiosApi.get, `/api/mail-gateway/settings/alert/${host}`);
    yield put(SuccessGetAlertSettings(response?.data?.alert_settings));
  } catch (e) {
    yield put(FailureGetAlertSettings());
    yield put(
      addNotification({
        message: "Failed to fetch alert settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setAlertSettings({ payload }) {
  const { host, reqBody } = payload;
  try {
    yield call(axiosApi.post, `/api/mail-gateway/settings/alert/${host}`, reqBody);
    yield put(SuccessSetAlertSettings());
    yield call(getAlertSettings, { payload: host });
    yield put(
      addNotification({
        message: "Defined settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetAlertSettings());
    yield put(
      addNotification({
        message: "Failed to set alert settings",
        options: { variant: "error" },
      }),
    );
  }
}

export function* nextHops({ payload: host }) {
  try {
    const response = yield call(axiosApi.get, `/api/mail-gateway/settings/next-hops/${host}`);
    yield put(SuccessNextHops(response?.data?.next_hops));
  } catch (e) {
    yield put(FailureNextHops());
  }
}

const mailGatewaySagas = [
  takeLatest(RequestDistinctHosts, distinctHosts),
  takeLatest(RequestDistinctLiveHosts, distinctLiveHosts),
  takeLatest(RequestAnalyzedEmails, analyzedEmails),
  takeLatest(RequestBlockedEmails, blockedEmails),
  takeLatest(RequestUnblockedEmails, unblockedEmails),
  takeLatest(RequestReleaseEmail, releaseEmail),
  takeLatest(RequestSetMailTransferSettings, setMailTransferSettings),
  takeLatest(RequestGetMailTransferSettings, getMailTransferSettings),
  takeLatest(RequestGetWhitelistSettings, getWhitelistSettings),
  takeLatest(RequestSetWhitelistSettings, setWhitelistSettings),
  takeLatest(RequestGetBlacklistSettings, getBlacklistSettings),
  takeLatest(RequestSetBlacklistSettings, setBlacklistSettings),
  takeLatest(RequestAptAnalysisStatus, aptAnalysisStatus),
  takeLatest(RequestDashboardInsights, dashboardInsights),
  takeLatest(RequestTransferLogs, transferLogs),
  takeLatest(RequestGetUrlSettings, getUrlSettings),
  takeLatest(RequestSetUrlSettings, setUrlSettings),
  takeLatest(RequestGetUrl2Settings, getUrl2Settings),
  takeLatest(RequestSetUrl2Settings, setUrl2Settings),
  takeLatest(RequestGetSandboxSettings, getSandboxSettings),
  takeLatest(RequestSetSandboxSettings, setSandboxSettings),
  takeLatest(RequestToggleUrlSettings, toggleUrlSettings),
  takeLatest(RequestToggleUrl2Settings, toggleUrl2Settings),
  takeLatest(RequestGetSpamSettings, getSpamSettings),
  takeLatest(RequestSetSpamSettings, setSpamSettings),
  takeLatest(RequestToggleSpamSettings, toggleSpamSettings),
  takeLatest(RequestGetEmailNotificationSettings, getEmailNotificationSettings),
  takeLatest(RequestSetEmailNotificationSettings, setEmailNotificationSettings),
  takeLatest(RequestResetSettings, resetSettings),
  takeLatest(RequestRepairSettings, repairSettings),
  takeLatest(RequestGetFileTypeSettings, getFileTypeSettings),
  takeLatest(RequestSetFileTypeSettings, setFileTypeSettings),
  takeLatest(RequestGetGeneralSettings, getGeneralSettings),
  takeLatest(RequestSetGeneralSettings, setGeneralSettings),
  takeLatest(RequestGetCertificateFile, getCertificateFile),
  takeLatest(RequestSetCertificateFile, setCertificateFile),
  takeLatest(RequestGetKeyFile, getKeyFile),
  takeLatest(RequestSetKeyFile, setKeyFile),
  takeLatest(RequestSendTestEmail, sendTestEmail),
  takeLatest(RequestGetAlertSettings, getAlertSettings),
  takeLatest(RequestSetAlertSettings, setAlertSettings),
  takeLatest(RequestNextHops, nextHops),
];

export default mailGatewaySagas;
